import type { ApiVersionResponse } from "@/types/ApiVersion";
import { log } from "../core/logger";
import { API_BASE_URL } from "./helpers";

/**
 * API for getting data from the API about the API itself
 */
class SystemAPI {
  /**
   * Perform a global search across multiple collections
   */
  async getApiVersion(): Promise<ApiVersionResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/health`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }

      const results: ApiVersionResponse = await response.json();
      return results;
    } catch (error) {
      log("systemApi", "Failed to get API version", error);
      return {} as ApiVersionResponse;
    }
  }
}

export default new SystemAPI();
